import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { RefTarget } from '@shared-ui/ref-context';

import { CurrentHotelStore } from 'stores/current-hotel-store';

// Components
import { SharedUiGalleryWrapper } from 'src/common/components/infosite/shared-ui/details/gallery-wrapper';

export interface PropertyDetailsProps {
  currentHotel?: CurrentHotelStore;
  priceRange?: string; // Experiment: 37997 Schema_PriceOnSERP_TrafficTest
}

@inject('currentHotel')
@observer
export class PropertyGallery extends React.Component<PropertyDetailsProps> {
  public render() {
    const { currentHotel, priceRange } = this.props;
    const { hotel } = currentHotel || {};
    const { hotelName, hotelOverviewA11yHeader } = hotel || {};

    return (
      <RefTarget name="Overview">
        <meta itemProp="name" content={hotelName} />
        <meta itemProp="priceRange" content={priceRange} />
        {hotelOverviewA11yHeader && <h2 className="is-visually-hidden">{hotelOverviewA11yHeader}</h2>}
        <SharedUiGalleryWrapper />
      </RefTarget>
    );
  }
}
